import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptySalesItems({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h240v168H0z" />
        <path
          d="M177.8 150.01c-39.25-5.43-77.3 12.49-102.3 12.49-40.5 0-80.22-29.03-67.63-70 12.89-41.9 44.95-32.48 107.29-71.78 57.4-36.2 102.49 19.82 111.6 51.53 9.13 31.7 3.72 85.05-48.96 77.76z"
          fill="#E9EDFB"
        />
        <path
          d="M225.01 126.8l-.4.9c-7.13 15.34-21.52 25.81-46.81 22.31-39.25-5.43-77.3 12.49-102.3 12.49-33.35 0-66.18-19.68-69.7-49.51C31 125.54 64.67 128 119.5 110.5c54.61-17.43 85.52-2.16 105.51 16.3z"
          fill="#8F9DD6"
          opacity={0.32}
        />
        <path fill="#CCD2EE" fillRule="nonzero" d="M85.96 59L110 34.96 134.04 59 110 83.04z" />
        <path fill="#FB8F23" d="M78 69h54v16H78z" />
        <path fill="#8F9DD6" d="M131 64.2l23.63-4.17 4 22.65-23.64 4.17z" />
        <path fill="#FFDA3B" d="M92 85h59v16H92z" />
        <g stroke="#7687CD" strokeWidth={6}>
          <path
            d="M60.34 39c4.73.74 7.75 4.01 9.07 9.81l16.66 73.5h66.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M71.03 55.1l85.83 11.24a6 6 0 014.9 7.88l-8.45 24.94a6 6 0 01-5.68 4.07H83.07" />
        </g>
        <path
          d="M138.18 134.57a8 8 0 1016 0 8 8 0 00-16 0m-57.62 0a8 8 0 1016 0 8 8 0 00-16 0"
          fill="#666"
          opacity={0.8}
        />
      </g>
    </svg>
  );
}

SvgPicEmptySalesItems.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptySalesItems.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptySalesItems svgRef={ref} {...props} />
));
export default ForwardRef;
